import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import i18next from "i18next";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import MnComboStandalone from "@mnjsplatform/components/lib/common/Dropdown/MnComboStandalone";

class WorkScheduleCreatePopup extends Component {
    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        this.initialize();
    }
    async initialize() {
        await this.props.dispatch(this.props.AppPers_ListTypeOnNewPO.reset());
        await this.props.dispatch(this.props.AppPers_ListTypeOnNewPO.execute());
    }
    createRequest = async () => {
        const row = this.props.AppPers_ListTypeOnNewPO.getRow(this.props.AppPers_ListTypeOnNewPO.getCurrentRowIndex());
        await this.props.dispatch(this.props.AppPers_New.execute({AppTypeIntId: row.AppTypeIntId}));
        const rowKey = this.props.AppPers_New.getRow(0);
        console.log(`rowKey: ${JSON.stringify(rowKey)}`);
        this.onClose({
            methodName: row.NameMethod,
            rowKey: rowKey,
            refresh: true,
            requestType: row.AppTypeName
        })
    }
    renderButtons = () => {
        return <div className="modal-footer text-right">
            <button type="button"
                    className="btn btn-regular -goahead  ml1ex"
                    onClick={this.createRequest}>{i18next.t("Create")}</button>
            <button type="button" className="btn btn-regular"
                    onClick={this.onClose}>{i18next.t("Cancel")}</button>
        </div>;
    }
    onClose = (props) => {
        if (this.props.onClose)
            this.props.onClose(props);
    }

    render() {
        return (<PopupWrapper popupVisible={true}
                              title={i18next.t("ChooseRequestTypeToChangeWorkSchedule")}
                              staticTitle={i18next.t("ChooseRequestTypeToChangeWorkSchedule")}
                              maxWidthBody="650px"
                              onClose={this.onClose} renderButtons={this.renderButtons}>
            <PlaceholderWrapper placeholderId="31" title={i18next.t("ChooseRequestTypeToChangeWorkSchedule")}
                                showInstruction={false}
                                showHeaderTitle={false} canCollapse={false} showSplitterLine={false}>
                <MnComboStandalone
                    ownItem={this.props.AppPers_ListTypeOnNewPO}
                    style={{cursor: 'pointer'}}
                    valueFieldName="AppTypeName"
                    withSearch={true} />
                <div className="col-md-3"></div>
            </PlaceholderWrapper>
        </PopupWrapper>)
    }
}

WorkScheduleCreatePopup.propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    AppPers_ListTypeOnNewPO: PropTypes.object,
    AppPers_New: PropTypes.object
};

WorkScheduleCreatePopup.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        AppPers_ListTypeOnNewPO: state.dailyChartState.AppPers_ListTypeOnNewPO,
        AppPers_New: state.dailyChartState.AppPers_New
    }
}

export default connect(mapStateToProps)(WorkScheduleCreatePopup)